<template>
    <div>
        <v-dialog 
            v-model="display"
            width="500"
            persistent>
            <v-card flat>
                <v-card-title>
                    {{ title }}
                    <!-- <v-spacer></v-spacer> -->
                    <!-- <v-switch v-if="notEditMode" label="SMS" v-model="form.send_sms"></v-switch> -->
                </v-card-title>
                <div class="text-center" v-if="loading.data">
                    <v-progress-circular
                        indeterminate>
                    </v-progress-circular>
                </div>
                <v-card-text v-else>
                    <v-form
                        v-model="valid"
                        ref="form">
                        <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="form.date"
                                :rules="rules.date"
                                :disabled="uneditableField('date')"
                                :label="$t('date')"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                            </template>
                            <v-date-picker v-model="form.date" @input="menu = false" no-title scrollable>
                            </v-date-picker>
                        </v-menu>
                        <v-text-field
                            autofocus
                            :append-icon="form.customer_id ? '' : 'mdi-magnify'"
                            :readonly="!!form.customer_id"
                            :clearable="true"
                            @click:clear="form.customer_id = null"
                            @keypress.enter="openCustomerSearchDialog"
                            @blur="!form.customer_id ? form.customer = null : null"
                            v-model="form.customer"
                            :rules="rules.customer"
                            :label="$t('customer')">
                        </v-text-field>
                        <!-- <p-customer-search 
                            v-model="form.customer_id"
                            :rules="rules.customer"
                            :idCustomer="form.customer_id"
                            @update:name="setCustomerName">
                        </p-customer-search> -->
                        <v-text-field
                            v-model="form.amount_formated"
                            :rules="rules.amount"
                            :value="formatPrice"
                            @change="formatAccounting('amount', 'SDG')"
                            :label="$t('amount')">
                        </v-text-field>
                        <v-select
                            v-model="form.payment_mode_id"
                            :items="paymentModes"
                            item-value="id"
                            item-text="name"
                            :label="$t('mode')">
                        </v-select>
                        <v-textarea
                            rows="2"
                            v-model="form.description"
                            :label="$t('description')">
                        </v-textarea>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        color="primary"
                        :disabled="loading.data || !valid || loading.submit"
                        :loading="loading.submit"
                        @click="submit"
                        >
                        {{ $t("save_btn" )}}
                    </v-btn>
                    <v-btn
                        text
                        color="error"
                        @click="close">
                        {{ $t("cancel_btn") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
        <AlertDialog
            ref="alertDialog"/>
        <CustomerSearchDialog
            @store="fetchCustomerName"
            ref="customerSearchDialog"/>
    </div>
</template>
<script>
import RetryDialog from '@/components/common/RetryDialog';
import AlertDialog from '@/components/common/AlertDialog';
import CustomerSearchDialog from '@/components/Sales/CustomerSearchDialog';
import uneditableField from '@/utils/uneditableField';
import { mapActions, mapState } from 'vuex';
import formatPrice from '../../utils/formatPrice';
import formatAccounting from '../../utils/formatAccounting';
// import PCustomerSearch from './PCustomerSearch.vue';


export default {
    name: "PaymentDialog",
    components: {
        RetryDialog,
        AlertDialog,
        CustomerSearchDialog,
        // PCustomerSearch
    },
    data() {
        return {
            display: false,
            openParams: null,
            valid: false,
            menu: false,
            mode: {
                edit: false
            },
            loading: {
                data: true,
                submit: false
            },
            form: {
                id: null,
                date: new Date().toISOString().substr(0, 10),
                customer: null,
                customer_id: null,
                amount: null,
                amount_formated: null,
                unformated: this.non_formated,
                payment_mode_id: null,
                description: null,
                send_sms: false
            },
            rules: {
                customer: [
                    v => !!v || this.$t("rules_required")
                ],
                amount: [
                    v => !!v || this.$t("rules_required")
                ], 
                payment_mode_id: [
                    v => !!v || this.$t("rules_required")
                ]
            },  
        }
    },
    computed: {
        ...mapState("sales/payment", ["payment"]),
        ...mapState('sales/paymentMode', ["paymentModes"]),
        title() {
            if(!this.mode.edit) return this.$t('new_payment')
            else return this.$t('edit_payment')
        },
        editMode() {
            return this.mode.edit;
        },
        notEditMode() {
            return !this.editMode;
        }
    },
    methods: {
        ...mapActions("sales/payment", ["fetchPayments", "fetchPayment", "storePayment", "updatePayment"]),
        ...mapActions('sales/paymentMode', ["fetchPaymentModes"]),
        ...mapActions('common/snackBar', ["setSnackBars"]),
        uneditableField,
        formatPrice,
        formatAccounting,
        ...mapActions("sales/dpk", ["fetchDpk"]),
        async getDpkData() {
            let dpk = await this.fetchDpk();
            this.form.dpk = dpk.key;
        },
        open(params) {
            this.mode.edit = params.editMode;
            this.openParams = params;
            this.loading.data = true;
            this.openDataFetch();
            this.display = true;
        },
        async openDataFetch() {
            try {
                if(this.mode.edit) {
                await this.fetchPayment(this.openParams.id);
                this.form = JSON.parse(JSON.stringify(this.payment));
                this.form.amount_formated = this.form.amount;
                } else { this.getDpkData(); }
                this.fetchPaymentModes();
                this.loading.data = false;
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target:"openDataFetch", message});
            }
        },
        setCustomerName(name) {
            this.form.customer = name;
        },
        onRetryDialogSubmit(params){
            if(params.target == "openDataFetch") {
                if(params.retry) this.openDataFetch();
                else this.close()
            }
        },
        openCustomerSearchDialog() {
            this.$refs.customerSearchDialog.open(this.form.customer);
        },
        fetchCustomerName(params) {
            this.form.customer_id =params.id;
            this.form.customer = params.name;
        },
        submit() {
            this.loading.submit =true;
            if(!this.mode.edit) {
                this.storePayment(this.form)
                    .then(() => {
                        this.close();
                        this.$emit('submit');
                        this.setSnackBars({color: "success", message: this.$t("record_save_success")});
                    })
                    .catch((error) => {
                        this.loading.submit = false;
                        let message = error.response ? error.response.data.message : error;
                        this.setSnackBars({color: "error", message});
                    })
            } else {
                this.updatePayment(this.form)
                    .then(() => {
                        this.close();
                        this.$emit('submit');
                        this.setSnackBars({color: "success", message: this.$t("record_update_success")});
                    })
                    .catch((error) => {
                        this.loading.submit = false;
                        let message = error.response ? error.response.data.message : error;
                        this.setSnackBars({color: "error", message});
                    })
            }

        },
        resetFeild(){
            this.form.customer_id = null;
            this.form.customer = null;
        },
        close() {
            Object.assign(this.$data, this.$options.data.apply(this));
            this.$refs.form.resetValidation();
            // this.display = false;
            // this.loading.submit = false;
            // this.resetFeild();
            // this.$refs.form.reset();
            // this.$refs.form.resetValidation();
        }
       
    },
}
</script>